import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';

export default function Address(props) {
  function handleChange(event) {
    let inputElement = document.getElementById(event.target.id);
    let errorElement = inputElement.nextSibling;
    if (event.target.value.trim().length === 0) {
      inputElement.classList.add('is-invalid');
      errorElement.innerHTML = 'The Address field should not be empty';
      errorElement.style.display = 'block';
    } else if (!/^[ a-zA-Z0-9\/-]+$/.test(event.target.value)) {
      inputElement.classList.add('is-invalid');
      errorElement.innerHTML =
        'The Address field should contain only letters, numbers, dash or slash';
      errorElement.style.display = 'block';
    } else if (
      props.isNotPO &&
      (!/(?!.*(?:[pP][oO] [bB][oO][xX]))^[ a-zA-Z0-9\\/-]+$/.test(
        event.target.value
      ) ||
        !/(?!.*(?:[pP][oO][bB][oO][xX]))^[ a-zA-Z0-9\\/-]+$/.test(
          event.target.value
        ) ||
        !/(?!.*(?:[pP][oO][sS][tT] [oO][fF][fF][iI][cC][eE] [bB][oO][xX]))^[ a-zA-Z0-9\\/-]+$/.test(
          event.target.value
        ) ||
        /\bP(ost|ostal)?([ \.]*(O|0)(ffice)?)?([ \.]*Box)\b/i.test(
          event.target.value
        ))
    ) {
      inputElement.classList.add('is-invalid');
      errorElement.innerHTML = 'PO Boxes are not acceptable.';
      errorElement.style.display = 'block';
    } else {
      errorElement.style.display = 'none';
      inputElement.classList.remove('is-invalid');
    }
    props.onChange(event);
  }

  return (
    <>
      <Form.Group as={Row} controlId={props.id} className="mb-3">
        <Form.Label column sm={6} required>
          {props.label}
        </Form.Label>

        <Form.Control
          type="text"
          placeholder={props.label}
          value={props.state[props.id] ? props.state[props.id] : ''}
          required
          maxLength="30"
          pattern="^[ a-zA-Z0-9\/\-]+$"
          onChange={handleChange}
          isInvalid={props.isInvalid}
          data-hj-allow
        />
        <Form.Control.Feedback type="invalid">
          The Address field should contain only letters, numbers, dash or slash
        </Form.Control.Feedback>
      </Form.Group>
    </>
  );
}
